import { render, staticRenderFns } from "./Quotes.vue?vue&type=template&id=c7970a82&scoped=true&"
import script from "./Quotes.vue?vue&type=script&lang=ts&"
export * from "./Quotes.vue?vue&type=script&lang=ts&"
import style0 from "./Quotes.vue?vue&type=style&index=0&id=c7970a82&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7970a82",
  null
  
)

export default component.exports